import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Settings } from '@mui/icons-material';
import { Button } from '@mui/material';

import styles from 'features/nav_bar/NavBar.module.css';

export function ManageButton() {
  const navigate = useNavigate();
  return (
    <Button
      className={styles.list_item_button}
      onClick={(e) => {
        navigate('/manage/projects');
      }}
      startIcon={<Settings />}
    >
      Manage
    </Button>
  );
}
